import React, { useEffect } from "react";

const Callback = () => {
    useEffect(() => {
        // 🔹 Get Authorization Code from URL
        const urlParams = new URLSearchParams(window.location.search);
        const authorizationCode = urlParams.get("code");

        if (!authorizationCode) {
            document.body.innerHTML = "Authorization code not found.";
            return;
        }

        // 🔹 Retrieve code_verifier from sessionStorage
        const codeVerifier = sessionStorage.getItem("code_verifier");

        if (!codeVerifier) {
            document.body.innerHTML = "Code verifier not found in session storage.";
            return;
        }

        // 🔹 Call ASP.NET API to exchange the authorization code for tokens
        fetch("https://excomatixapi.betaphase.in/accountservices/api/account/AuthenticateWithOkta", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Api-Key": "f238b70537400820398f84fa1e1d12344314914eb7803d96b2ad497efed288d5" // Replace with the actual API key
            },
            body: JSON.stringify({
                AuthorizationCode: authorizationCode,
                CodeVerifier: codeVerifier
            })
        })
            .then(response => response.json())
            .then(data => {
                document.body.innerHTML = "Authentication Successful: " + JSON.stringify(data);
            })
            .catch(error => {
                document.body.innerHTML = "Authentication Failed: " + error;
            });
    }, []);

    return (
        <div>
            <h6>Authenticating...</h6>
        </div>
    );
};

export default Callback;
